import { getAnalytics, isSupported } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';

export const createFirebaseApp = () => {
  if (process.env.NEXT_PUBLIC_DEPLOY_ENV === 'PROD') {
    const firebaseConfig = {
      apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
      authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
      storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
      measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
    };

    // Ensure the code is only running on the client-side (browser)

    // Check if Firebase Analytics is supported
    isSupported()
      .then((supported) => {
        if (supported) {
          // Initialize Firebase
          const app = initializeApp(firebaseConfig);
          const analytics = getAnalytics(app);
          console.log('Firebase Analytics initialized.');
        } else {
          console.log(
            'Firebase Analytics is not supported in this environment.',
          );
        }
      })
      .catch((error) => {
        console.error('Error initializing Firebase Analytics:', error);
      });
  }
};
